import { render, staticRenderFns } from "./accountManagerHeader.vue?vue&type=template&id=2f28074e&"
import script from "./accountManagerHeader.vue?vue&type=script&lang=js&"
export * from "./accountManagerHeader.vue?vue&type=script&lang=js&"
import style0 from "./accountManagerHeader.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports